import { Box, Menu, MenuItem } from "@mui/material";
import { clearOpenSections } from "components/app/App.slice";
import Typography from "components/common/Typography";
import ActionCardDialogsContext from "components/features/ActionCard/Context";
import { flowOptions, setCustomPlanCreationFlow, setPlanMode } from "components/features/CustomPlanCreation/CustomPlanCreation.slice";
import CreatePlanButton from "components/features/MyPlans/Create/CreatePlanButton";
import { useTranslate } from "hooks/useTranslate";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { routes } from "utils/routes";
import { formTypes } from "utils/Types";

interface Props {
  formType?: string;
  label?: string;
  showMenu?: boolean;
  buttonSize?: any;
  sx?: any;
}

function CreateMyPlan(props: Readonly<Props>) {
  const { formType = formTypes.CreatePlan } = props;

  const translate = useTranslate();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { setIsOpenCustomPlanCreateDialog } = React.useContext(ActionCardDialogsContext);

  const { isAbovePropertyUser } = useAppSelector((state) => state.app.loggedInUserDetails);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const openCreateMenu = Boolean(anchorEl);

  React.useEffect(() => {
    dispatch(clearOpenSections());
  }, [dispatch]);

  const getOnClickForCreatePlan = (event: React.MouseEvent<HTMLElement>) => {
    if (isAbovePropertyUser || props.showMenu) handleOpenCreateMenu(event);
    else {
      dispatch(setPlanMode(formType));
      setIsOpenCustomPlanCreateDialog(true);
    }
  };

  const handleOpenCreateMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const MenuItems = {
    ABOVE_PROPERTY: [
      {
        id: 1,
        title: translate("myplan.PropertyPlan"),
        subtitle: translate("myplan.createPropertyPlan"),
        onClick: () => {
          dispatch(setPlanMode(formType));
          setAnchorEl(null);
          setIsOpenCustomPlanCreateDialog(true);
        }
      },
      {
        id: 2,
        title: translate("myplan.TemplatePlan"),
        subtitle: translate("myplan.createTemplatePlan"),
        onClick: () => {
          dispatch(setPlanMode(formTypes.CreateTemplatePlan));
          setAnchorEl(null);
          dispatch(setCustomPlanCreationFlow(flowOptions["third"]));
          setIsOpenCustomPlanCreateDialog(true);
        }
      }
    ],
    HOTEL_USER: [
      {
        id: 3,
        title: "Create Custom Plan",
        subtitle: "Tailor the plan precisely to your needs",
        onClick: () => {
          dispatch(setPlanMode(formType));
          setIsOpenCustomPlanCreateDialog(true);
        }
      },
      {
        id: 4,
        title: "Add Library Plan",
        subtitle: "Save time by choosing from library plans",
        onClick: () => navigate(routes.Library)
      }
    ]
  };

  return (
    <>
      <CreatePlanButton {...props} getOnClickForCreatePlan={getOnClickForCreatePlan} />
      <Menu
        id="create-menu"
        anchorEl={anchorEl}
        open={openCreateMenu}
        onClose={() => {
          setAnchorEl(null);
        }}
        sx={{
          ".MuiList-root": {
            padding: "0",
            margin: "8px"
          }
        }}
      >
        {(isAbovePropertyUser ? MenuItems["ABOVE_PROPERTY"] : MenuItems["HOTEL_USER"]).map((item) => {
          return (
            <MenuItem key={item.id} onClick={item.onClick}>
              <Box>
                <Typography variant="body2" showBold sx={{ color: tokens.Text.General.PrimaryHeadline }}>
                  {item.title}
                </Typography>
                <Typography variant="label" sx={{ color: tokens.Text.General.Secondary, whiteSpace: "normal" }}>
                  {item.subtitle}
                </Typography>
              </Box>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
}

export default CreateMyPlan;
